<template>
  <nav-bar title="违法举报" />
  <van-search
    v-model="words"
    placeholder="输入关键词"
    input-align="center"
    @search="onSearch"
  />
  <Content :bottom="0" :top="102" @content-scroll="handleContentScroll">
    <Loading v-if="showLoading" :isLoading="isLoading" @reload="getList" />
    <ul v-if="list.length" class="information-list">
      <li v-for="item in list" :key="item.reportId" class="information-list-item" >
        <div class="information-list-item__title">{{item.title}}</div>
        <div class="information-list-item__date">举报时间：{{item.reportTime}}</div>
        <div class="information-list-item__status">{{item.reportStatusName}}</div>
        <van-button size="small" style="margin-top: 10px;" @click="handleItemClick(item)" block>详细</van-button>
        <van-button size="small" style="margin-top: 10px;" v-if="item.reportStatus === '0' && roleId === '6'" type="primary" :to="`/supervise2/${item.companyId}`" block>督办</van-button>
        <van-button size="small" style="margin-top: 10px;" v-if="item.reportStatus === '0' && roleId === '1'" type="primary" :to="`/HandlingReports/${item.reportId}`" block>处理</van-button>
      </li>
    </ul>
    <Empty
        v-else
        :description="
          searchWords ? `没有找到与‘${searchWords}’的相关信息` : '请输入关键词搜索'
        "
      />
    <!-- 加载更多 -->
    <loading-more v-if="list.length" :finished="finished" :showLoadingMore="showLoadingMore" :loadingFail="loadingFail" :list="list" @reload="getList" />
  </Content>
  <Popup ref="popup" title="举报信息" minHeight="100%">
    <div class="popup-content">
      <div class="popup-content__title">{{detail.title}}</div>
      <div class="popup-content__info">
        <span>状态：{{detail.reportStatusName}}</span>
        <span>举报时间：{{detail.reportTime}}</span>
      </div>
      <div class="popup-content__company">钢瓶所属公司：{{detail.companyName}}</div>
      <h3>举报内容：</h3>
      <div class="popup-content__text">{{detail.content}}</div>
      <div>
        <van-image
          v-for="item in detail.reportPicList"
          style="margin-right: 10px;"
          width="100"
          height="100"
          fit="cover"
          :key="item"
          :src="item"
        />
      </div>
      <template v-if="detail.reportStatus !== '0'">
        <h2>处理信息：</h2>
        <div class="popup-content__info">
          <span>处理人：{{detail.finishUserName}}</span>
          <span>处理时间：{{detail.finishTime}}</span>
        </div>
        <h3>处理意见：</h3>
        <div class="popup-content__text">{{detail.finishRemark}}</div>
        <div>
        <van-image
          v-for="item in detail.donePicList"
          style="margin-right: 10px;"
          width="100"
          height="100"
          fit="cover"
          :key="item"
          :src="item"
        />
      </div>
      </template>
    </div>
  </Popup>
</template>

<script>
import { Toast } from 'vant'
import { ref, watch, computed } from 'vue'
import { getReportList, getDetail } from '@/api/list'
import { useLoadingMore } from '@/hooks/useLoadingMore'
import { useStore } from 'vuex'
export default {
  name: 'IllegaReporting',
  setup () {
    const store = useStore()
    const roleId = computed(() => store.state.roleInfo.roleId)
    const comId = computed(() => store.state.roleInfo.companyId)
    const words = ref('')
    const data = useLoadingMore(getReportList)
    const {
      getList,
      list,
      finished,
      loadingFail,
      pageParams
    } = data

    // 初始化list
    list.value = []
    pageParams.page = 1
    pageParams.roleId = roleId.value
    pageParams.comId = comId.value
    pageParams.title = ''
    finished.value = false
    loadingFail.value = false
    getList()

    // 举报详情
    const popup = ref(null)
    const detail = ref({})
    const handleItemClick = ({ reportId }) => {
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: '请稍后...'
      })
      getDetail(reportId).then(res => {
        detail.value = res.data
        Toast.clear()
        popup.value.showPopup()
      }).catch(() => {
        Toast.clear()
      })

      // popup.value.show = true
    }

    const searchWords = ref('')
    watch(() => words.value, (val) => {
      if (val === '') {
        searchWords.value = ''
      }
    })
    const onSearch = value => {
      searchWords.value = value
      if (searchWords.value) {
        list.value = []
        pageParams.page = 1
        pageParams.title = value
        finished.value = false
        loadingFail.value = false
        getList()
      } else {
        Toast('请输入客户名称')
      }
    }
    return {
      detail,
      popup,
      handleItemClick,
      ...data,
      words,
      onSearch,
      searchWords,
      roleId
    }
  }
}
</script>

<style lang="scss" scoped>
.information-list {
  padding:16px 16px 0 16px;
  .information-list-item {
    padding: 10px 16px;
    font-size: 16px;
    background-color: #fff;
    box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
    margin-bottom: 16px;
    color: #666;
    line-height: 24px;
    &__title {
      font-size: 14px;
      font-weight: 600;
      color: #333
    }
    &__status {
      font-size: 14px;
      color: #666
    }
    &__date {
      font-size: 14px;
      color: #999
    }
  }
}
.text {
  font-size: 14px;
  text-indent: 24px;
  color: #666;
}
.popup-content {
  font-size: 12px;
  padding: 16px;
  &__info {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #999;
    margin: 16px 0;

  }
  &__title {
    text-align: left;
    font-size: 16px;
    font-weight: 600;
    color: #333
  }
  &__text {
    font-size: 14px;
    color: #666;
    line-height: 24px;
    background-color: #f8f8f8;
    padding: 16px;
    margin-bottom: 16px;
  }
  &__company {
    color: #999;
  }
}
</style>
